<template>
  <div class="marangoni-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>τ = dγ / dx | 液体从低表面张力向高处流动$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Petri dish -->
          <ellipse cx="200" cy="120" rx="150" ry="80" fill="rgba(34, 166, 179, 0.2)" stroke="#22a6b3" />
          
          <!-- Liquid surface -->
          <ellipse cx="200" cy="120" rx="140" ry="70" fill="rgba(34, 166, 179, 0.1)" />

          <!-- Soap/Alcohol drop at center -->
          <circle v-if="active" :cx="200" :cy="120" :r="radius" fill="white" opacity="0.3">
             <animate attributeName="r" values="0;120" dur="2s" fill="freeze" />
             <animate attributeName="opacity" values="0.8;0" dur="2s" fill="freeze" />
          </circle>

          <!-- Floating particles being pushed away -->
          <circle v-for="p in particles" :key="p.id" :cx="p.x" :cy="p.y" r="2" fill="#ffd700" />
          
          <!-- Labels -->
          <text x="70" y="60" fill="#888" font-size="8">高张力 (水)</text>
          <text x="175" y="135" :fill="active ? '#fff' : '#888'" font-size="8">{{ active ? '释放表面活性剂' : '点击开始实验' }}</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>实验模拟: {{ active ? '张力不均产生强力扩散' : '静态平衡' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="primary" size="mini" @click="trigger">滴入表面活性剂 (如肥皂/酒精)</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>马拉贡尼效应（Marangoni Effect）描述了液体由于**表面张力梯度**而发生的传质现象。当液体表面某处的张力降低时（例如滴入洗洁精），周围高张力的液体会产生一个拉力，将低张力区域的液体强力向外牵引。这种现象在日常生活中随处可见：如“酒泪”现象（酒精挥发导致张力梯度使液膜上升）、以及在肥皂水中木条快速弹开。它是研究微流控、熔焊技术和晶体生长的重要课题。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarangoniEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      active: false,
      radius: 0,
      particles: [],
      timer: null
    }
  },
  methods: {
    initParticles() {
       this.particles = [];
       for (let i = 0; i < 40; i++) {
          let angle = Math.random() * Math.PI * 2;
          let r = Math.random() * 40;
          this.particles.push({
             id: i,
             x: 200 + Math.cos(angle) * r,
             y: 120 + Math.sin(angle) * r,
             vx: 0,
             vy: 0,
             angle: angle
          });
       }
    },
    trigger() {
       this.active = true;
       this.radius = 0;
       this.initParticles();
       setTimeout(() => { this.active = false; }, 2000);
    },
    update() {
       if (this.active) {
          this.particles.forEach(p => {
             p.x += Math.cos(p.angle) * 5;
             p.y += Math.sin(p.angle) * 2; // Follow ellipse aspect
          });
       }
       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.initParticles(); this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.marangoni-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(34, 166, 179, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
